import { render } from "./physicalAssessment.vue?vue&type=template&id=07ced8c5&scoped=true"
import script from "./physicalAssessment.vue?vue&type=script&lang=js"
export * from "./physicalAssessment.vue?vue&type=script&lang=js"

import "./physicalAssessment.vue?vue&type=style&index=0&id=07ced8c5&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ced8c5"]])

export default __exports__